import { FormlyFieldConfig } from "@ngx-formly/core";

export class AdminCreateDocumentTemplateForm {
  fields: FormlyFieldConfig[];
  model: {};
  actionText = 'button.save';

  constructor(translateService, dataUsers, dataCompanies, user, config?) {

    const companies: {value: string | null, label: string}[] = [];
    for(const company of dataCompanies) companies.push({value: company['_id'], label: company['name'] });

    const users: {value: string | null, label: string}[] = [];
    for(const user of dataUsers) users.push({value: user['_id'], label: `${user['name']} (${user['email']})` });

    const defaultJson = {
      "name": "Plantilla APFE Coruña",
      "defaults": {
        "fontSize": 7,
        "font": "Helvetica"
      },
      "sections": []
    }

    this.fields = [
      {
        key: 'name',
        type: 'input',
        wrappers: ['default-wrapper'],
        props: {
          required: true,
        },
        expressions: {
          'props.label': translateService.stream('fields.name')
        }
      },
      {
        key: 'owner',
        type: 'select',
        wrappers: ['default-wrapper'],
        props: {
          required: true,
          options: users
        },
        expressions: {
          'props.label': translateService.stream('fields.owner')
        }
      },
      {
        key: 'company',
        type: 'select',
        wrappers: ['default-wrapper'],
        props: {
          options: companies,
          required: true
        },
        expressions: {
          'props.label': translateService.stream('fields.company')
        }
      },
      {
        key: 'type',
        type: 'select',
        wrappers: ['default-wrapper'],
        defaultValue: 'report',
        props: {
          options: [{label: 'Report', value: 'report'}],
          required: true
        },
        expressions: {
          'props.label': translateService.stream('fields.type')
        }
      },
      {
        key: 'templateJson',
        type: 'textarea',
        wrappers: ['float-label-wrapper'],
        defaultValue: JSON.stringify(defaultJson, undefined, 4),
        props: {
          required: true,
        },
        expressions: {
          'props.label': translateService.stream('fields.templateJson')
        }
      },
    ]
  }
}

export class AdminEditDocumentTemplateForm {
  fields: FormlyFieldConfig[];
  model: {};
  actionText = 'button.save';

  constructor(translateService, currentData, dataUsers, dataCompanies, user, config?) {

    const companies: {value: string | null, label: string}[] = [];
    for(const company of dataCompanies) companies.push({value: company['_id'], label: company['name'] });

    const users: {value: string | null, label: string}[] = [];
    for(const user of dataUsers) users.push({value: user['_id'], label: `${user['name']} (${user['email']})` });

        this.fields = [
      {
        key: 'name',
        type: 'input',
        wrappers: ['default-wrapper'],
        defaultValue: currentData.name,
        props: {
          required: true,
        },
        expressions: {
          'props.label': translateService.stream('fields.name')
        }
      },
      {
        key: 'owner',
        type: 'select',
        wrappers: ['default-wrapper'],
        defaultValue: currentData.owner._id,
        props: {
          required: true,
          options: users
        },
        expressions: {
          'props.label': translateService.stream('fields.owner')
        }
      },
      {
        key: 'company',
        type: 'select',
        wrappers: ['default-wrapper'],
        defaultValue: currentData.company._id,
        props: {
          options: companies,
          required: true
        },
        expressions: {
          'props.label': translateService.stream('fields.company')
        }
      },
      {
        key: 'type',
        type: 'select',
        wrappers: ['default-wrapper'],
        defaultValue: currentData.type,
        props: {
          options: [{label: 'Report', value: 'report'}],
          required: true
        },
        expressions: {
          'props.label': translateService.stream('fields.type')
        }
      },
      {
        key: 'templateJson',
        type: 'textarea',
        wrappers: ['float-label-wrapper'],
        defaultValue: JSON.stringify(currentData.templateJson, undefined, 4),
        props: {
          required: true,
        },
        expressions: {
          'props.label': translateService.stream('fields.templateJson')
        }
      },
    ]
  }
}